import { ICompany } from '../../../../types/api-Types';
import { RootState } from '../../../rootReducer';

export const selectSelectedCompanyState = (state: RootState): ICompany | undefined => {
  return state.companies.selectedCompany.data;
};
